import Portal from 'client/widget-components/components/Portal';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { useBookingContext } from '../../../Context';
import { BookerStateContext } from '../../../hooks/useRuntimeCalBookingState';
import { CalBookerStep } from '../../../types';
import BackButton from '../../BackButton';

interface BookerBackButtonProps {
    calBookerStep: CalBookerStep | null;
}

const BookerBackButton = ({ calBookerStep }: BookerBackButtonProps) => {
    const bookerContext = useBookingContext();
    const [bookingState, bookingActions] = useContext(BookerStateContext);
    const [rootEl, setRootEl] = useState<HTMLElement | null>(null);
    const isMultipleEvents = bookerContext.events.length > 1;
    const isSelectingTimeBookerView =
        calBookerStep === CalBookerStep.SELECTING_TIME;
    const isConfirmationFormBookerView =
        calBookerStep === CalBookerStep.BOOKING;
    // don't render back button if there are no events or if we are on the selecting time step and there is only one event
    if (
        !calBookerStep ||
        (isSelectingTimeBookerView && !isMultipleEvents) ||
        (isSelectingTimeBookerView && bookingState.rescheduleUid)
    ) {
        return null;
    }

    const handleBack = () => {
        if (isSelectingTimeBookerView) {
            bookingActions.setEventSlug(null);
            bookingActions.setSelectedHost(null);
        } else if (isConfirmationFormBookerView) {
            bookingActions.resetBookerState();
        }
    };

    return (
        <span
            ref={(el) => {
                setRootEl(el?.closest('.event-meta-container') as HTMLElement);
            }}
        >
            {rootEl && (
                <Portal rootEl={rootEl}>
                    <StyledBookerBackButton onClick={handleBack} />
                </Portal>
            )}
        </span>
    );
};

const StyledBookerBackButton = styled(BackButton)`
    && {
        margin-top: auto;
        padding-top: 16px;
        align-self: flex-start;
    }
`;

export default BookerBackButton;
